import React, { useEffect } from 'react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { Outlet, matchPath, useLocation } from 'react-router-dom';
import { PRAYER_HUB_ROUTE, PRAYER_ROUTE } from 'src/constants/routes';
import { useIsApiBusy } from 'src/store/api/selectors';

import 'src/styles/index.scss';

import AuthInit from 'src/components/common/AuthInit';
import Head from 'src/components/common/Head';
import { useAppSelector } from 'src/hooks';
import { selectAuth, selectUserId } from 'src/store/user/selectors';
import { theme } from 'src/theme';
import prayerStats from 'src/utils/stats';

import Preloader from '../Preloader';

const PageLayout = () => {
  const userId = useAppSelector(selectUserId);
  const userAuth = useAppSelector(selectAuth);
  const location = useLocation();
  const isApiBusy = useIsApiBusy();
  const isPrayerHubPage = Boolean(matchPath({ path: PRAYER_HUB_ROUTE, end: true }, location.pathname));
  const isPrayerPage = Boolean(matchPath({ path: PRAYER_ROUTE, end: true }, location.pathname));

  useEffect(() => {
    if (userId) {
      prayerStats.init(userId);
    }
  }, [userId]);

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {!isPrayerHubPage && <Head />}
        <AuthInit />
        <Outlet />
        <Preloader visible={(userAuth.isInProgress || isApiBusy) && !isPrayerPage} />
      </ThemeProvider>
    </>
  );
};

export default PageLayout;
